import { flattenToAppURL } from '@plone/volto/helpers';
import { formatDate } from '@plone/volto/helpers/Utils/Date';

/**
 * Normalize image download URL coming from image_scales or fields
 * @param {Object} item - Plone content item with @id
 * @param {string|Object} url - Raw image URL or image_scale object
 * @returns {string} Resolved image URL
 */  

export const resolveImageURL = (item, url) => {
  if (!url) return '';
  
  // Accept objects with a 'download' property
  if (typeof url === 'object' && url.download) {
    url = url.download;
  }
  // Flatten absolute API URLs
  const flattened = flattenToAppURL(url);
  if (flattened !== url) return flattened;

  // Prefix relative scale paths like '@@images/...'
  if (url.startsWith('@@') || url.startsWith('/@@')) {
    if (!item) return '';
    const base = flattenToAppURL(item['@id'] || item.url || '');
    return `${base.replace(/\/$/, '')}/${url.replace(/^\/+/, '')}`;
  }
  // Already an app URL or external absolute URL
  return url;
};

/**
 * Extract YouTube video ID from a URL
 * @param {string} url - URL to check
 * @returns {boolean} True if URL is a YouTube link, false otherwise
 */   

export const isYouTubeUrl = (url) => {
  if (!url) return false;
  return (
    url.includes('youtube.com') || url.includes('youtu.be')
  );
};

export const getFormattedDate = (date) => {
  const newDate = new Date(date);
  return newDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}

export const getYear = (date) => {
  const newDate = new Date(date);
  return newDate.getFullYear();
}

const newsDateformatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});

export const formatNewsDate = (date) => {
  return newsDateformatter.format(new Date(date));
};

 /**
 * Strip HTML tags from a string to get plain text.
 * Used to pass RichText content as plain text to components like PageHeaderBackground.
 */
export const stripHTML = (html) => {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '');
};